export { UserMoveAlt2 as default } from './UserMoveAlt2';
